import React from 'react';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { isMobile } from 'react-device-detect';
import { redirectToOrderDetails } from '@src/utils/general';
import { RefundTotal } from '@src/components/shared/RefundTotal';
import { useSummaryStore } from '@src/stores/summaryStore';
import { useReturnStore } from '@src/stores/returnStore';

const BareboneSummary = () => {
  const orderDetailsPath = useReturnStore((state) => state.orderDetailsPath);
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );
  const refundValues = useSummaryStore((state) => state.refundValues);
  const returnToInitialPage = () =>
    redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest);

  return (
    <div>
      {/* // TODO: set a standard width for all pages? */}
      <div className="sui-max-w-[555px]">
        <div className="sui-text-center sui-mb-8">
          <div className="sui-text-[216px] sui-leading-[0] sui-mb-8">
            <ConfirmedFilled color="success" size="inherit" />
          </div>
          <div className="sui-mb-3">
            <Typography variant={isMobile ? 'h2' : 'h1'} lineHeight="tight">
              Return request submitted!
            </Typography>
          </div>
          <Typography
            variant={isMobile ? 'body-sm' : 'body-base'}
            lineHeight={isMobile ? 'tight' : undefined}
          >
            Go to Order Details to see your return status. Updates may take 5
            minutes to appear.
          </Typography>
        </div>
        <RefundTotal sessionValues={refundValues} />
        <div className="sui-flex sui-flex-row-reverse sui-w-full sui-my-12 sm:sui-my-[60px]">
          <Button variant="primary" onClick={returnToInitialPage}>
            {isMilitaryExchangeGuest
              ? 'Track Another Order'
              : 'Back to Order Details'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BareboneSummary;
